/**
 * 欄位關係配置索引
 * 管理所有表單的關係配置
 */

import { FormRelationshipConfig } from '../relationship-types';

// 匯入所有配置檔案
import { ExampleProjectFormConfig } from './example-project-form.config';
import { SampleFormConfig } from './sample-form.config';
import { WorkOrderFormConfig } from './work-order-form.config';
import { ContractorConstructionFormConfig } from './contractor-construction-form.config';
// import { ProjectApplicationConfig } from './project-application.config';
// import { SafetyInspectionConfig } from './safety-inspection.config';

/**
 * 所有表單關係配置的映射表
 * 鍵值：formId，值：對應的關係配置
 */
export const FORM_RELATIONSHIP_CONFIGS: { [formId: string]: FormRelationshipConfig } = {
  // 範例配置 (可以用來測試)
  'example-project-form': ExampleProjectFormConfig,
  'sample-form': SampleFormConfig,

  // 實際生產環境配置
  'c625f5bb-d804-4b52-8d77-8b6f4640e24d': WorkOrderFormConfig,          // 派工單
  'b05f45f4-8083-460e-9f18-f89bf23883ad': ContractorConstructionFormConfig,  // 施工申請單_承攬商填寫
  // '6a8bed49-6f22-4977-9417-b2e2a43f1f6d': WorkApplicationFormConfig,   // 施工申請單 (JSAI) - 已改用方案 B（直接在 dynamic-form 設定日期限制）

  // 'proj-app-001': ProjectApplicationConfig,
  // 'safety-check-001': SafetyInspectionConfig,

  // ========================================
  // 在這裡新增您的表單關係配置
  // ========================================
  // 'your-actual-form-id': YourFormConfig,
};

/**
 * 根據 formId 取得關係配置
 * @param formId 表單ID
 * @returns 關係配置物件或 null
 */
export function getRelationshipConfig(formId: string): FormRelationshipConfig | null {
  const config = FORM_RELATIONSHIP_CONFIGS[formId];
  
  if (config) {
    console.log(`[FieldRelationship] Found config for formId: ${formId}`);
    return config;
  }
  
  return null;
}

/**
 * 取得所有已註冊的表單ID列表
 */
export function getRegisteredFormIds(): string[] {
  return Object.keys(FORM_RELATIONSHIP_CONFIGS);
}

/**
 * 檢查表單是否有關係配置
 */
export function hasRelationshipConfig(formId: string): boolean {
  return formId in FORM_RELATIONSHIP_CONFIGS;
}